import { useEffect } from "react";
import PropTypes from "prop-types";
import { withState } from "react-searchkit";

// Add a prop to identify the page/module
const SessionFiltersPersistence = ({
  currentQueryState,
  updateQueryState,
  moduleIdentifier = "documents", // Default value if not provided
}) => {
  // Create a page-specific storage key
  const FILTER_STORAGE_KEY = `filters-${moduleIdentifier}`;

  // Helper functions with page-specific keys
  const saveFiltersToSession = (filters) => {
    sessionStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(filters));
  };

  const getFiltersFromSession = () => {
    try {
      const storedFilters = sessionStorage.getItem(FILTER_STORAGE_KEY);
      return storedFilters ? JSON.parse(storedFilters) : null;
    } catch (error) {
      return null;
    }
  };

  // When filters change, save them to session storage
  useEffect(() => {
    if (currentQueryState?.filters && currentQueryState?.filters.length > 0) {
      saveFiltersToSession(currentQueryState?.filters);
    }
  }, [currentQueryState?.filters]);

  // On component mount, check if we have stored filters and apply them
  useEffect(() => {
    const storedFilters = getFiltersFromSession();
    if (
      storedFilters &&
      storedFilters.length > 0 &&
      (!currentQueryState?.filters || currentQueryState?.filters.length === 0)
    ) {
      // Apply stored filters
      updateQueryState({
        ...currentQueryState,
        filters: storedFilters,
      });
    }
  }, []);

  // This is a utility component that doesn't render anything
  return null;
};

SessionFiltersPersistence.propTypes = {
  currentQueryState: PropTypes.object.isRequired,
  updateQueryState: PropTypes.func.isRequired,
  moduleIdentifier: PropTypes.string, // New prop to identify the page
};

export default withState(SessionFiltersPersistence, {
  queryState: "queryState",
});
